import { createContext, useContext, useState, useCallback } from 'react';
import BadgeEarnedNotification from '../components/ui/BadgeEarnedNotification';

const BadgeNotificationContext = createContext();

export const useBadgeNotification = () => {
  const context = useContext(BadgeNotificationContext);
  if (!context) {
    throw new Error('useBadgeNotification must be used within BadgeNotificationProvider');
  }
  return context;
};

export const BadgeNotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const showBadgeNotification = useCallback((badge) => {
    const id = Date.now();
    const notification = { id, badge };
    
    setNotifications(prev => [...prev, notification]);

    // Auto-remove after 8.5 seconds (slightly longer than animation)
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 8500);
  }, []);

  const removeBadgeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }, []);

  return (
    <BadgeNotificationContext.Provider value={{ showBadgeNotification }}>
      {children}
      
      {/* Render notifications */}
      {notifications.map(notification => (
        <div key={notification.id}>
          {/* Dark overlay */}
          <div className="badge-notification-overlay" />
          
          {/* Notification */}
          <BadgeEarnedNotification
            badge={notification.badge}
            onClose={() => removeBadgeNotification(notification.id)}
          />
        </div>
      ))}
    </BadgeNotificationContext.Provider>
  );
};
